export const endpoints = {
  createAccount: '/account/create',
  updateAccount: '/account/update',
}
